import Pikaday from 'pikaday';

function Datepicker() {
    var picker = new Pikaday({ field: document.getElementById('id_date') });
}

export default Datepicker;
